import React, { useState, useEffect } from "react";
import { Stack, Typography, CircularProgress, Box } from "@mui/material";
import { fetchCustomerParametersService } from "../../services/global";

const Footer = () => {
  const [loading, setLoading] = useState(true);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const loadLogo = async () => {
      const storedLogo = localStorage.getItem("logo");
      if (storedLogo && storedLogo !== "undefined") {
        setLogo(storedLogo);
        setLoading(false);
      } else {
        // Fetch from API if not in localStorage
        await fetchCustomerParametersService();
        const newLogo = localStorage.getItem("logo");
        if (newLogo && newLogo !== "undefined") {
          setLogo(newLogo);
        }
        setLoading(false);
      }
    };
    loadLogo();

    // Listen for logo changes
    const handleStorageChange = () => {
      const updatedLogo = localStorage.getItem("logo");
      if (updatedLogo && updatedLogo !== "undefined") {
        setLogo(updatedLogo);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Determine logo width based on specific logos
  const getLogoWidth = () => {
    if (logo === "https://assets-global.website-files.com/64cc5a89d4d4629cd9a9c005/64cc5a89d4d4629cd9a9c180_Pear-Logo-Green-dark-2021%2520(1)-p-500.png") {
      return "70px";
    }
    if (logo === "https://images.squarespace-cdn.com/content/v1/5d15f3e498ee850001ff9375/1563189206465-X9SJ0K3W6YHIGYK7LTYE/pinto-brothers-logo.jpg?format=100w") {
      return "50px";
    }
    if (logo === "https://mma.prnewswire.com/media/2508619/Knit_Logo.jpg?w=100") {
      return "60px";
    }
    return "100px";
  };

  return (
    <Stack
      component="footer"
      direction="row"
      borderTop="1px solid #dee6ed"
      bgcolor="#fff"
      paddingBlock="0.75rem"
      paddingInline="1rem"
      justifyContent="space-between"
      alignItems="center"
    >
      {/* Customer Logo - Left */}
      <Box sx={{ minWidth: "100px", display: "flex", alignItems: "center" }}>
        {loading ? (
          <CircularProgress size={16} />
        ) : logo ? (
          <img
            src={logo}
            alt="Customer Logo"
            style={{
              width: getLogoWidth(),
              height: "auto",
              maxHeight: "32px",
              objectFit: "contain",
            }}
          />
        ) : (
          <Box sx={{ width: "100px" }} />
        )}
      </Box>

      {/* Copyright - Right */}
      <Typography
        variant="body1"
        color="#737d85"
        fontWeight="300"
      >
        &copy; {new Date().getFullYear()} -{" "}
        <Typography
          component="span"
          fontWeight="300"
          variant="caption"
          color="#737d85"
        >
          Datajolt v0.9986
        </Typography>
      </Typography>
    </Stack>
  );
};

export default Footer;
